import {Component, Injector, OnInit} from '@angular/core';
import {BasePropostaComponent} from '../base-proposta';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {ProdutoService} from '../../../core/services/produto.service';
import {AppComponent} from '../../../app.component';
import {CategoriaPlanoService} from '../../../core/services/categoria_plano.service';
import {CupomService} from '../../../core/services/cupom.service';
import {PropostaService} from '../../../core/services/proposta.service';
import {CepService} from '../../../core/services/cep.service';
import {Meta, Title} from '@angular/platform-browser';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-confirmacao-compra',
    templateUrl: './confirmacao-compra.component.html',
    styleUrls: ['./confirmacao-compra.component.sass']
})
export class ConfirmacaoCompraComponent  extends BasePropostaComponent implements OnInit {

    constructor(
        public cupomService: CupomService,
        public propostaService: PropostaService,
        public router: Router,
        public cepService: CepService,
        public toast: ToastrService,
        public categoriaPlanoService: CategoriaPlanoService,
        public appComponent: AppComponent,
        public titleService: Title,
        public meta: Meta,
        public produtoService: ProdutoService,
        public deviceService: DeviceDetectorService,
        protected injector: Injector,
        ) {
        super(injector);
    }

    async ngOnInit() {
        await this.inOnInit();
        await this.propostaService.finalizarPropostaSiteDesktop();
    }
}
